import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { flowRight as compose } from 'lodash';
import { graphql } from 'react-apollo';
import * as FontAwesome from 'react-icons/fa';

import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Footer.css';
import Link from '../Link';
import { Container, Row, Col } from 'react-bootstrap';
import cx from 'classnames';

import getAllHomePageSettings from './getAllHomePageSettings.graphql'
import getContentPageDetails from './getContentPage.graphql'

import AppStoreIcon from '../../../public/SiteImages/app-store.png';
import googleIcon from '../../../public/SiteImages/play-store.png';

import messages from '../../locale/messages';
import history from '../../history';

const SECTION_LINKS = [
  { id: 'home', label: <FormattedMessage {...messages.home} /> },
  { id: 'about', label: <FormattedMessage {...messages.about} /> },
  { id: 'services', label: 'Our Services' },
  { id: 'how-it-works', label: <FormattedMessage {...messages.howItWorks} /> },
  { id: 'faq', label: <FormattedMessage {...messages.faq} /> },
  { id: 'news', label: 'News' },
  { id: 'footer-section', label: <FormattedMessage {...messages.contact} /> },
];
class Footer extends React.Component {
  scrollToSection(e, id) {
    if (e) e.preventDefault();
    const doScroll = () => {
      const el = typeof document !== 'undefined' && document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    };
    if (history.location.pathname !== '/') {
      history.push('/');
      setTimeout(doScroll, 350);
    } else {
      doScroll();
    }
  }

  render() {
    const { getAllHomePageSettings: { loading, getAllHomePageSettings } } = this.props
    const { getContentPageDetails: { getContentPageDetails } } = this.props;
    const { youtubeLink, twitterLink, facebookLink, instagramLink, siteName } = this.props

    let homeSettings = {}
    if (!loading && getAllHomePageSettings && getAllHomePageSettings.homePageData) {
      getAllHomePageSettings && getAllHomePageSettings.homePageData.map((item) => {
        homeSettings[item.name] = item.value
      })
    }

    return (
      <div>
        {!loading && getAllHomePageSettings && getAllHomePageSettings.homePageData &&
          <div className={cx(s.footer, s.heroBkgAnimated, 'homeFooter')} id="footer-section">
            <Container fluid className={cx(s.cotainerWith)}>
              <Row>
                <Col lg={4} md={4} sm={12} xs={12} className={cx(s.space3)}>
                  <div className={cx(s.content, 'contentRTL')}>
                    <h3>Main Office</h3>
                    <p>
                      PT Unreal Digital Apps<br />
                      Jalan Sawe Batu Riti No. 2, Desa/Kelurahan Kuta,<br />
                      Kec. Pujut, Kab. Lombok Tengah,<br />
                      Provinsi Nusa Tenggara Barat 83573
                    </p>
                  </div>
                </Col>
                <Col lg={4} md={4} sm={12} xs={12} className={cx(s.space3)}>
                  <div className={cx(s.content, s.secondSectionPadding, 'contentRTL')}>
                    <h3>{homeSettings && homeSettings.footerLinkTitle}</h3>
                    <ul>
                      {SECTION_LINKS.map((item) => (
                        <li key={item.id}>
                          <a
                            href={`#${item.id}`}
                            onClick={(e) => this.scrollToSection(e, item.id)}
                          >
                            {item.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </Col>
                <Col lg={4} md={4} sm={12} xs={12} className={cx(s.space3)}>
                  <div className={cx(s.content, 'contentRTL')}>
                    <h3>
                      <span className={s.eatsColor}>SCAN QR CODE</span>
                      
                    </h3>
                    <div>
                      <img src="/SiteImages/appsQRcode.png" alt="Apps" />
                      <Col xs={12} sm={12} md={12} lg={12} className={cx(s.noPadding, s.googleIconMargin)}>
                        <div>
                          <div className={cx(s.displayInlineBlock, s.paddingRight, 'footerAppRTL')}>
                            <a href={homeSettings.safetyGridLink1} target="_blank">
                              <img src={googleIcon} className={s.appIconImg} alt="googlePlay" />
                            </a>
                          </div>
                          <div className={cx(s.displayInlineBlock)}>
                            <a href={homeSettings.safetyGridLink2} target="_blank">
                              <img src={AppStoreIcon} className={s.appIconImg} alt="app-store" />
                            </a>
                          </div>
                        </div>
                      </Col>
                    </div>
                    <ul>
                      <li className={cx(s.displayInlineBlock, s.iconPaddingRight)}>
                        <a href={facebookLink} target="_blank" className={s.fontAwesomeIcon}>
                          <FontAwesome.FaFacebook />
                        </a>
                      </li>
                      <li className={cx(s.displayInlineBlock, s.iconPaddingRight)}>
                        <a href={instagramLink} target="_blank" className={s.fontAwesomeIcon}>
                          <FontAwesome.FaInstagram />
                        </a>
                      </li>
                      <li className={cx(s.displayInlineBlock, s.iconPaddingRight)}>
                        <a href={twitterLink} target="_blank" className={s.fontAwesomeIcon}>
                          <FontAwesome.FaTwitter />
                        </a>
                      </li>
                      <li className={cx(s.displayInlineBlock, s.iconPaddingRight)}>
                        <a href={youtubeLink} target="_blank" className={s.fontAwesomeIcon}>
                          <FontAwesome.FaYoutube />
                        </a>
                      </li>
                      <li className={cx(s.displayInlineBlock, 'iconPaddingRightRTL')}>
                        <a href="https://wa.me/6285183317338" target="_blank" className={s.fontAwesomeIcon}>
                          <FontAwesome.FaWhatsapp />
                        </a>
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
              <div className={s.copyRight}>
                {homeSettings && homeSettings.footerBottom}
              </div>
            </Container>
          </div>
        }
      </div>
    );
  }
}

const mapState = (state) => ({
  youtubeLink: state.siteSettings.data.youtubeLink,
  twitterLink: state.siteSettings.data.twitterLink,
  facebookLink: state.siteSettings.data.facebookLink,
  instagramLink: state.siteSettings.data.instagramLink,
  siteName: state.siteSettings.data.siteName
})

const mapDispatch = {}

export default compose(
  withStyles(s),
  connect(mapState, mapDispatch),
  graphql(getAllHomePageSettings, {
    name: 'getAllHomePageSettings',
    options: {
      ssr: true
    }
  }),
  graphql(getContentPageDetails, {
    name: 'getContentPageDetails',
    options: {
      fetchPolicy: "network-only",
      ssr: false
    }
  })
)(Footer);
